import { FC, useState } from "react";
import { Portal, formStyles } from "shared/ui";
import { SupportTicketsModal } from "./SupportTicketsModal";
import { TicketThreadModal } from "./TicketThreadModal";

interface Props {
  className?: string;
}

const DEFAULT_CLASS = `${formStyles.outlineButton} ${formStyles.accent}`;

export const SupportTicketsButton: FC<Props> = ({
  className = DEFAULT_CLASS,
}) => {
  const [isListOpen, setIsListOpen] = useState(false);
  const [ticketId, setTicketId] = useState<number | null>(null);

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={() => setIsListOpen(true)}
      >
        My requests
      </button>

      <Portal>
        {isListOpen && (
          <SupportTicketsModal
            // Список прячем, пока открыт тред, — после закрытия вернёмся к нему.
            isOpen={ticketId === null}
            onClose={() => setIsListOpen(false)}
            onOpenTicket={setTicketId}
          />
        )}
        {ticketId !== null && (
          <TicketThreadModal
            ticketId={ticketId}
            onClose={() => setTicketId(null)}
          />
        )}
      </Portal>
    </>
  );
};
